import React from "react";
import "./ContactMe.scss";
import ContactMeImg from "../../Assets/Images/contact-me.svg";
import emailjs from "emailjs-com";
import { Fade } from "react-reveal";

const ContactMe = () => {
  const sendMail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_k0bs8bi",
        "template_ya9o85c",
        e.target,
        "user_JBN3lzKnkwHErmVEzawAh"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };
  return (
    <>
      <div className="contact-me-area">
        <div className="container custom-padding-top custom-padding-bottom text-light">
          <Fade bottom>
            <h1 className="custom-font display-3 py-5 text-center">
              Lets do a Chat<span className="orange-dot">.</span>
            </h1>
          </Fade>
          <div className="row gx-0">
            <Fade left>
              <div className="col-md-6 d-flex align-items-center justify-content-center">
                <div className="image">
                  <img
                    className="contact-me-img mb-5"
                    src={ContactMeImg}
                    alt=""
                  />
                </div>
              </div>
            </Fade>
            <Fade right>
              <div className="col-md-6">
                <form onSubmit={sendMail} className="needs-validation row gx-0">
                  <div class="mb-3">
                    <label
                      for="exampleFormControlInput1"
                      class="form-label fw-bold"
                    >
                      Your Name<span className="orange-dot">.</span>
                    </label>
                    <input
                      name="from_name"
                      type="text"
                      class="form-control"
                      id="exampleFormControlInput1"
                      placeholder="name@example.com"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label
                      for="exampleFormControlInput1"
                      class="form-label fw-bold"
                    >
                      Email address<span className="orange-dot">.</span>
                    </label>
                    <input
                      name="from_email"
                      type="email"
                      class="form-control"
                      id="exampleFormControlInput1"
                      placeholder="name@example.com"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label
                      for="exampleFormControlTextarea1"
                      class="form-label fw-bold"
                    >
                      Description<span className="orange-dot">.</span>
                    </label>
                    <textarea
                      name="message"
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      rows="4"
                      required
                    />
                    <div className="invalid-feedback">
                      Please say me something
                    </div>
                  </div>
                  <div className="submit-btn-area">
                    <button
                      className="btn submit-btn mb-5 px-5 py-3"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactMe;
